export default "__VITE_ASSET__7134e267__"